import type { GeoPoint } from './geo';

export interface PlaceResult {
  id: string;
  name: string;
  lat: number;
  lon: number;
  type?: string;
}

/** Forward geocoding via OSM Nominatim. */
export async function searchPlaces(query: string, signal?: AbortSignal): Promise<PlaceResult[]> {
  const params = new URLSearchParams({ format: 'jsonv2', q: query, limit: '6' });
  const res = await fetch(`https://nominatim.openstreetmap.org/search?${params.toString()}`, {
    signal: signal ?? AbortSignal.timeout(10000),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = (await res.json()) as Array<{
    place_id: number;
    display_name: string;
    lat: string;
    lon: string;
    type?: string;
  }>;
  return data.map((d) => ({
    id: String(d.place_id),
    name: d.display_name,
    lat: Number(d.lat),
    lon: Number(d.lon),
    type: d.type,
  }));
}

/** Reverse geocode a point to a human-readable place name. */
export async function reverseGeocode(loc: GeoPoint, signal?: AbortSignal): Promise<string | null> {
  const params = new URLSearchParams({
    format: 'jsonv2',
    lat: loc.lat.toFixed(4),
    lon: loc.lon.toFixed(4),
    zoom: '10',
  });
  const res = await fetch(`https://nominatim.openstreetmap.org/reverse?${params.toString()}`, {
    signal: signal ?? AbortSignal.timeout(10000),
  });
  if (!res.ok) return null;
  const data = (await res.json()) as { display_name?: string };
  return data.display_name ?? null;
}
